var carrousel = {transitionSpeed: 'normal', doAnimate: true, lastPan: null};
carrousel.transitionSpeed = 100;
carrousel.doAnimate = false;

carrousel.init = function ($root) {
	var $slideList = $("[data-role='carrousel']", $root);
	var $buttonList = $("[data-role='carrousel-button']", $root);
	carrousel.actuel = null;
	carrousel.lastPan = null;

	if ( $slideList.length > 1 ) {
		$slideList.hide();
		var storedState = preferences.getItemLocation('carrouselIdref');
		if ( storedState && ($('#' + storedState, $root).length > 0) ) {
			carrousel.select(storedState, $root);
		} else {
			carrousel.select($($slideList[0]).attr('id'), $root);
		}

		$buttonList.on('click', function(){
	        carrousel.select($(this).attr('idref'));
	        popover.hide();
	    });

      $(".imagePastilleWrapper", $root).hammer({recognizers: [[Hammer.Pan, {direction: Hammer.DIRECTION_HORIZONTAL, threshold: 20}]]})
	    .on("panstart pancancel", function(theEvent) {
	    	carrousel.lastPan = null;
	    })
	    .on("panend", function(theEvent) {
	    	switch ( carrousel.lastPan ) {
	    		case "panleft" :
	        		carrousel.next();
	       			popover.hide();
	       			break;
	    		case "panright" :
	        		carrousel.previous();
	       			popover.hide();
	       			break;
	    	}
	    	carrousel.lastPan = null;
	    })
	    .on("panleft panright", function(theEvent) {
	        carrousel.lastPan = theEvent.type;
	    })
	    .on("touchstart", function(theEvent){
		    popover.hide();
	    });
	}
}

carrousel.select = function (idref, $root) {
	if ( carrousel.actuel != idref ) {
		if ( carrousel.doAnimate ) {
			$('#' + carrousel.actuel, $root).fadeOut(carrousel.transitionSpeed);
		} else {
			$('#' + carrousel.actuel, $root).hide();
		}
    $('[idref='+carrousel.actuel+"]", $root).removeClass("current");

		carrousel.actuel = idref;
		preferences.setItemLocation('carrouselIdref', carrousel.actuel);

		if ( carrousel.doAnimate ) {
			$('#' + carrousel.actuel, $root).fadeIn(carrousel.transitionSpeed, carrousel.afterCarrouselSlideDisplay);
		} else {
			$('#' + carrousel.actuel, $root).show(0, carrousel.afterCarrouselSlideDisplay);
		}

    $('[idref='+idref+"]", $root).addClass("current");
	}
}

carrousel.afterCarrouselSlideDisplay = function () {
    carrousel.updateController();
    pap.retinaLoadInContext($("#content"));
}

carrousel.updateController = function () {
    if ( typeof createKnobNavigation !== "undefined" ) createKnobNavigation();
    if ( typeof bindTouchEvents !== "undefined" ) bindTouchEvents();
}

carrousel.previous = function () {
	var $slideList = $("[data-role='carrousel']");
	if ( $slideList.length > 0 ) {
		var idref = $($slideList[$slideList.length - 1]).attr('id');
		for ( var index = 1; index < $slideList.length; index++ ) {
			if ( $($slideList[index]).attr('id') == carrousel.actuel ) {
				idref = $($slideList[index - 1]).attr('id');
				break;
			}
		}
		carrousel.select(idref);
	}
}

carrousel.next = function () {
	var $slideList = $("[data-role='carrousel']");
	if ( $slideList.length > 0 ) {
		var idref = $($slideList[0]).attr('id');
		for ( var index = 0; index < $slideList.length - 1; index++ ) {
			if ( $($slideList[index]).attr('id') == carrousel.actuel ) {
				idref = $($slideList[index + 1]).attr('id');
				break;
			}
		}
		carrousel.select(idref);
	}
}
